import { useState } from 'react'
import CommonModal from '../../ResetContext/components/DumpModal'
import { Button } from '@mui/material'

const AddBalanceModal = ({ isOpen, onClose, userActiveLocation, service, saveActiveLocation }) => {
    const [input, setInput] = useState(1)
    const [loading, setLoading] = useState(false)

    const handleSubmit = async () => {
        // alert(agency.Balance)
        setLoading(true);
        // alert(amount)
        const payload = {
            Balance: input,
            type: "credit",
            agency_id: userActiveLocation?.agency_id,
            account_id: userActiveLocation?._id,
            customer_id: userActiveLocation?.customer_id
        };

        var { response } = await service.accounts.AddBalance({
            payload,
        });
        if (response) {
            if (response.PaymentDone) {
                const payload = {
                    payment_confirm: "success",
                    Balance: input,
                    type: "credit",
                    agency_id: userActiveLocation?.agency_id,
                    logs_id: response.Balance_logs._id,
                    account_id: userActiveLocation?._id,
                    customer_id: userActiveLocation?.customer_id

                };
                const updatedata = await service.accounts.AddBalance({
                    payload,
                    toaster: true,
                });
                console.log(updatedata.response, 'updatedata')
                if (updatedata.response.success) {
                    saveActiveLocation(updatedata.response.data);
                    onClose();
                }
            } else {
                onClose()
            }
        }
    };
    return (
        <CommonModal isOpen={isOpen} onClose={onClose} showAlert={false} title='Add Balance'>
            <div className='flex flex-col'>
                <label htmlFor="" className='mb-1'>Amount</label>
                <input type="number" value={input} onChange={(e) => setInput(e.target.value)} placeholder='Amount' className='px-3 py-2 border !border-gray-300 rounded-lg !outline-none' />
                <div className='mt-3 flex justify-end gap-2'>
                    <Button variant="outlined" color='error' className='!bg-white !text-[#f26363] !normal-case' onClick={onClose}>Close</Button>
                    <Button variant="outlined" sx={{ border: "1px solid gray", color: "black" }} className='!normal-case hover:!border hover:!border-gray-500' disabled={loading} onClick={handleSubmit}>{loading ? "wait..." : 'Add'}</Button>
                </div>
            </div>
        </CommonModal>
    )
}

export default AddBalanceModal